import type { PromptResolve } from '@ur-solutions/react-components'
import { useForm, useTranslate } from '@ur-solutions/react-hooks'
import { Checkbox, RegularModal, TextArea } from '@/components_deprecated'
import { Field } from '@/modules/companies'

interface ApproveCommentModalProps {
  existingComment: string
  existingApproved: boolean
  onSubmit: PromptResolve<{ comment: string; approved: boolean } | null>
}

export const ApproveCommentModal: React.FC<ApproveCommentModalProps> = ({
  existingComment,
  existingApproved,
  onSubmit,
}) => {
  const translations = useTranslate({
    comment: 'common.comment',
    approve: 'salary.confirm-hours',
  })

  const { formValues: form, formChangeHandler } = useForm<{
    comment: string
    approved: boolean
  }>({
    values: {
      comment: existingComment,
      approved: !existingComment || existingApproved,
    },
  })

  return (
    <RegularModal
      title={translations.comment}
      width="400px"
      onCancel={() => onSubmit(null)}
      onSubmit={() =>
        onSubmit({ comment: form.comment, approved: form.approved })
      }
      cancelOnClickOutside
    >
      <TextArea
        width="100%"
        value={form.comment}
        onChange={formChangeHandler('comment')}
        onClick={evt => {
          evt.stopPropagation()
          evt.preventDefault()
        }}
      />
      <Field>
        <label>{translations.approve}</label>
        <Checkbox
          labelPosition="left"
          checked={form.approved}
          onChange={formChangeHandler('approved')}
          alignLeft
        />
      </Field>
    </RegularModal>
  )
}
